import * as React from 'react';
import styled from 'styled-components';

import { useSelector } from 'react-redux';
import { ButtonMain } from '../atoms';
import {
  ActionPanelMore,
  BreadCrumbs,
  SearchBar,
  InputSelect,
} from '../molecules';
import { RootState } from '../redux/root';

const ActionsPanel = ({
  onSearch,
  onAdd,
  buttonTitle = 'Add',
  isBreadCrumbsVisible = true,
  isActionPanelMoreVisible = true,
  className,
  addTicket,
  isAllActivities,
  isSaveDisabled,
  emergencyOptions,
  onEmergencySortChange,
  emergencySort,
  selectedInspections,
  isInspectionsPath,
  sendInspectionsEmail,
}: Props) => {
  const searchToken = useSelector((s:RootState) => s.filters.searchToken);
  return (
    <Container className={className}>
      <Part>{isBreadCrumbsVisible && <BreadCrumbs />}</Part>
      <Part>
        {onSearch && <SearchContainer><SearchBar text={searchToken} onChange={onSearch} /></SearchContainer>}
        {onAdd && !addTicket && (
        <ButtonMain onClick={onAdd} disabled={isSaveDisabled}>
          {buttonTitle}
        </ButtonMain>
      )}
        {onAdd && addTicket && (
        <StylesButtonMain onClick={onAdd}>
          {buttonTitle}
        </StylesButtonMain>
      )}
        {isAllActivities && (
        <>
          {isInspectionsPath && (
            <ButtonWrapper>
              <StylesButtonMain
                disabled={!selectedInspections?.length}
                onClick={sendInspectionsEmail}
              >
                Send Inspection Request
              </StylesButtonMain>
            </ButtonWrapper>
          )}
          <SelectWrapper>
            <InputSelect
              isSearchable={false}
              defaultValue={emergencyOptions[0]}
              onChange={onEmergencySortChange}
              value={emergencySort}
              options={emergencyOptions}
              getOptionValue={(item: any) => item.value}
              getOptionLabel={(item: any) => item.title}
            />
          </SelectWrapper>
        </>
      )}
        {isActionPanelMoreVisible && <ActionPanelMore />}
      </Part>
    </Container>
);
};

const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
  background: var(--secondary);
  min-height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 20px;
  flex-wrap: wrap;
  &.action-container {
    background: none;
    justify-content: left;
  }

  @media only screen and (max-width: 840px) {
    padding: 8px 14px;
  }

  @media only screen and (max-width: 540px) {
    padding: 8px 10px;
    gap: 8px;
  }
`;

const SelectWrapper = styled.div`
  width: 200px;

  @media only screen and (max-width: 540px) {
    width: 100%;
  }
`;

const Part = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  min-width: 0;

  > * {
    margin: 0;
  }

  .MuiButton-root,
  .MuiInputBase-root {
    height: 30px;
  }

  @media only screen and (max-width: 540px) {
    width: 100%;
    gap: 8px;
  }
`;

const StylesButtonMain = styled(ButtonMain)`
  margin: 0 !important;
  .MuiButton-root {
    margin: 0 !important;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const SearchContainer = styled.div`
  div {height: 40px!important}
  min-width: 0;
  @media only screen and (max-width: 540px) {
    width: 100%;
    flex: 1 1 100%;
    > div {
      width: 100% !important;
    }
  }
`; // Sandeep EA-323
interface Props {
  onAdd?: () => void;
  onSearch?: (value: string) => void;
  onEmergencySortChange?: (value: string) => void;
  sendInspectionsEmail?: () => void;
  buttonTitle?: string;
  isBreadCrumbsVisible?: boolean;
  isActionPanelMoreVisible?: boolean;
  className?: string;
  addTicket?: boolean;
  isAllActivities?: boolean;
  isInspectionsPath?: boolean;
  emergencySort?: any;
  emergencyOptions?: Array<Object>;
  selectedInspections?: Array<Object>;
}

export default ActionsPanel;
